import { createGlobalStyle, css } from 'styled-components';

export const GlobalDraggingStyle = createGlobalStyle<{ isDragging: boolean }>`
  ${({ isDragging }) =>
    isDragging &&
    css`
      body,
      body * {
        cursor: grabbing !important;
      }
    `}
`;
